import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFirebase } from "../../../context/FirebaseContext";
import "./AdminLoginPage.css";

const AdminAuthComplete = () => {
    const navigate = useNavigate();
    const { currentUser, storeInfo, userRole, loading, isAuthenticated } = useFirebase();

    // Simple redirect for authenticated users
    useEffect(() => {
        if (!loading) {
            if (isAuthenticated() && currentUser && storeInfo && userRole === 'store_owner') {
                navigate("/admin/dashboard", { replace: true });
            } else if (isAuthenticated() && currentUser && storeInfo && userRole === 'superAdmin') {
                navigate("/admin/super-admin-dashboard", { replace: true });
            } else {
                navigate("/admin/login", { replace: true });
            }
        }
    }, [loading, currentUser, storeInfo, userRole, isAuthenticated, navigate]);

    // Loading state while checking authentication
    return (
        <div className="admin-login-container">
            <div className="admin-login-card">
                <div className="admin-login-header">
                    <h1>Checking Authentication</h1>
                    <p>Redirecting you to the appropriate page...</p>
                </div>
                <div className="loading-spinner">
                    <div className="spinner"></div>
                    <p>Please wait...</p>
                </div>
            </div>
        </div>
    );
};

export default AdminAuthComplete;